// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");

// ---------------------------------------------------------------------------------------------
// Globalize Jquery import, some plugin does not correctly recognize its installation in webpack
// ---------------------------------------------------------------------------------------------
import $ from "jquery";
window.$ =      $;
window.jQuery = $;

// ---------------------------------------------------------------------------------------------
// --------------------------------- Basic plugin for bootstrap --------------------------------
// ---------------------------------------------------------------------------------------------
import "popper.js";
import "bootstrap";

// ---------------------------------------------------------------------------------------------
// -------------------------------------- Plugin´s for app -------------------------------------
// ---------------------------------------------------------------------------------------------
import "cocoon-js";
import "@fortawesome/fontawesome-free/js/all";
import swal from 'sweetalert';
import "select2";
import jsPDF from "jspdf";
import 'jspdf-autotable';
window.jsPDF = jsPDF;
// ----------------------------- Components required for DataTables ----------------------------
import JSZip from "jszip";
window.JSZip = JSZip;

var pdfMake = require( "pdfmake/build/pdfmake.js" );
var pdfFonts = require( "pdfmake/build/vfs_fonts.js" );
pdfMake.vfs = pdfFonts.pdfMake.vfs;

require( "datatables.net" );
require( "datatables.net-bs4" );
require( "datatables.net-buttons-bs4" )( window, $ );
require( "datatables.net-buttons/js/buttons.html5.js" )( window, $ );
require( "yadcf" );
// ---------------------------------------- Datepicker ----------------------------------------
import "bootstrap-datepicker";
// ------------------------------------------ Tree ------------------------------------------
import "./jstree/jstree";
import "./own/ctrl_tree";

// ---------------------------------------- Chartkick -----------------------------------------
require("chartkick");
require("chart.js");
// ---------------------------------------------------------------------------------------------

// ---------------------------------------------------------------------------------------------
// ------------------------------------- Inspinia template -------------------------------------
// ---------------------------------------------------------------------------------------------
import "./inspinia/slimscroll.min";
import "./inspinia/metisMenu";
import "./inspinia/inspinia";

// ---------------------------------------------------------------------------------------------
// ----------------------------------- Own Javascript for app ----------------------------------
// ---------------------------------------------------------------------------------------------
import "./own/init_plugins";
import "./own/init_sweetalert";
import "./own/ctrl_datatable";
import "./own/ctrl_tabs";
import "./own/ctrl_questions";
import "./own/ctrl_reports";
import "./own/ctrl_country_reports";
import "./own/ctrl_reportpdf";
import "./own/ctrl_translate";
import "./own/ctrl_gaps";
import "./own/ctrl_action_plan";
import "./own/ctrl_type_reports";

// ---------------------------------------------------------------------------------------------
// ------------------------------------ Stylesheets for app ------------------------------------
// ---------------------------------------------------------------------------------------------
import "../stylesheets/application";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require("trix")
require("@rails/actiontext")